import { jwtDecode } from "jwt-decode";
import SessionStorage from "./SessionStorage.utils";

export const ADMIN_ROLE_MASTER = "MASTER";
export const ADMIN_ROLE_SUB = "SUB";

export const getAdminTokenPayload = () => {
  const adminSession = SessionStorage.getItemJsonParse("adminSession");

  if (!adminSession?.accessToken) return null;

  try {
    return jwtDecode(adminSession.accessToken);
  } catch (error) {
    return null;
  }
};

export const getAdminTokenPayloadFromToken = (accessToken) => {
  if (!accessToken) return null;

  try {
    return jwtDecode(accessToken);
  } catch (error) {
    return null;
  }
};

export const getAdminRole = () => {
  const payload = getAdminTokenPayload();
  return payload?.admin_role === ADMIN_ROLE_SUB ? ADMIN_ROLE_SUB : ADMIN_ROLE_MASTER;
};

export const isSubAdmin = () => getAdminRole() === ADMIN_ROLE_SUB;
export const isMasterAdmin = () => getAdminRole() === ADMIN_ROLE_MASTER;

/**
 * 저장된 로그인 정보를 지우고 로그인 화면으로 보낸다 — refresh token 만료처럼 다시 로그인해야만 풀릴 때 쓴다.
 * 보던 주소는 로그인 후 돌아오도록 RequireAuth 와 같은 adminReturnUrl 에 남긴다.
 * @returns {boolean} 로그인 화면으로 이동했으면 true (이미 로그인 화면이면 정보만 지우고 false)
 */
export const redirectToLogin = () => {
  window.localStorage.removeItem("adminSession");
  window.localStorage.removeItem("isLoggedIn");

  const { pathname, search } = window.location;

  if (/^\/login\/?$/i.test(pathname)) return false;

  window.sessionStorage.setItem("adminReturnUrl", `${pathname}${search || ""}`);
  window.location.replace("/Login");

  return true;
};
